import { render, staticRenderFns, recyclableRender, components } from "./share.vue?vue&type=template&id=69245246&scoped=true&"
var renderjs
import script from "./share.vue?vue&type=script&lang=js&"
export * from "./share.vue?vue&type=script&lang=js&"
import style0 from "./share.vue?vue&type=style&index=0&id=69245246&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69245246",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/share/share.vue"
export default component.exports